module.exports = __webpack_public_path__ + "static/img/rs_js_15.70f57e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rs/rs_js_15.png
// module id = 5V9h
// module chunks = 1